import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page not found" description="The page you're looking for doesn't exist." path="/404" noindex />
      <section className="flex min-h-[60vh] items-center justify-center bg-[#FFD700] py-20">
        <div className="mx-auto max-w-2xl px-4 text-center md:px-8">
          <div className="display text-7xl font-black md:text-9xl">404</div>
          <h1 className="display mt-4 text-3xl font-black md:text-4xl">Lost in the warehouse.</h1>
          <p className="mt-3 text-base text-black/70">The page you're looking for has been moved or doesn't exist.</p>
          <Link to="/" className="btn-brutal dark mt-8 inline-flex">Take me home</Link>
        </div>
      </section>
    </>
  );
}
